import React from "react";

function currentYear({ year }) {
  return <span className="current-year">{year}</span>;
}

export default currentYear;
